document.addEventListener('DOMContentLoaded', function() {
  // Wait for custom elements to be defined
  customElements.whenDefined('header-menu').then(() => {
    initAccessibleDropdowns();
  });
  
  function initAccessibleDropdowns() {
    const dropdownContainers = document.querySelectorAll('.menu-item-with-dropdown');
    
    dropdownContainers.forEach(container => {
      const toggle = container.querySelector('.dropdown-toggle');
      const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      
      if (!toggle || !submenu) return;
      
      // Click functionality for dropdown toggle
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        
        // Close all other dropdowns first
        closeAllDropdowns();
        
        if (!isExpanded) {
          openDropdown(toggle, submenu);
        }
      });
      
      // Keyboard navigation
      toggle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle.click();
        }
        
        if (e.key === 'Escape') {
          closeDropdown(toggle, submenu);
        }
      });
      
      // Hover functionality (only on devices that support hover)
      if (window.matchMedia('(hover: hover)').matches) {
        container.addEventListener('mouseenter', () => {
          openDropdown(toggle, submenu);
        });
        
        container.addEventListener('mouseleave', () => {
          // Only auto-close if no element within has focus
          if (!container.contains(document.activeElement)) {
            closeDropdown(toggle, submenu);
          }
        });
      }
    });
    
    // Handle submenus
    const submenuContainers = document.querySelectorAll('.submenu-item-with-dropdown');
    submenuContainers.forEach(container => {
      const toggle = container.querySelector('.submenu-dropdown-toggle');
      if (!toggle) return;
      
      const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!submenu) return;
      
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          closeDropdown(toggle, submenu);
        } else {
          openDropdown(toggle, submenu);
        }
      });
      
      if (window.matchMedia('(hover: hover)').matches) {
        container.addEventListener('mouseenter', () => {
          openDropdown(toggle, submenu);
        });
        
        container.addEventListener('mouseleave', () => {
          if (!container.contains(document.activeElement)) {
            closeDropdown(toggle, submenu);
          }
        });
      }
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.menu-item-with-dropdown, .submenu-item-with-dropdown')) {
        closeAllDropdowns();
      }
    });
  }
  
  function openDropdown(toggle, submenu) {
    toggle.setAttribute('aria-expanded', 'true');
    submenu.removeAttribute('hidden');
    submenu.setAttribute('aria-expanded', 'true');
  }
  
  function closeDropdown(toggle, submenu) {
    toggle.setAttribute('aria-expanded', 'false');
    submenu.setAttribute('hidden', '');
    submenu.setAttribute('aria-expanded', 'false');
  }
  
  function closeAllDropdowns() {
    const allToggles = document.querySelectorAll('.dropdown-toggle, .submenu-dropdown-toggle');
    allToggles.forEach(toggle => {
      const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (submenu) {
        closeDropdown(toggle, submenu);
      }
    });
  }
});